<template>
  <div class="bottom">
    <div class="box1">
      <div class="main">
        <table cellspacing="0">
          <tr class="tr">
            <td>关于九象</td>
            <td>产品中心</td>
            <td>解决方案</td>
            <td>应用案例</td>
            <td>联系我们</td>
          </tr>
          <tr>
            <td><a @click="childClick('introduction', 0, 1)">公司简介</a></td>
            <td><a @click="childClick('productSite', 0, 2)">智慧工地</a></td>
            <td><a @click="childClick('live', 0, 3)">智慧住建</a></td>
            <td><a @click="childClick('witSite', 2, 3)">智慧工地</a></td>
            <td><a @click="childClick('contact', 0, 5)">联系方式</a></td>
          </tr>
          <tr>
            <td><a @click="childClick('introduction', 1, 1)">发展历程</a></td>
            <td><a @click="childClick('productSafety', 1, 1)">智慧安全</a></td>
            <td><a @click="childClick('site', 2, 3)">智慧工地</a></td>
            <td><a @click="childClick('applySafety', 2, 3)">智慧安全</a></td>
            <!-- <td><a @click="childClick('contact',1,5)">招贤纳士</a></td> -->
          </tr>
          <tr>
            <td><a @click="childClick('introduction', 2, 1)">发展态势</a></td>
            <td><a @click="childClick('productCartoon', 2, 1)">工程动画</a></td>
            <td><a @click="childClick('schemeSafety', 2, 3)">智慧安全</a></td>
            <td><a @click="childClick('applyCartoon', 2, 3)">工程动画</a></td>
          </tr>
          <tr>
            <td><a @click="childClick('introduction', 3, 1)">发展目标</a></td>
            <td></td>
            <td><a @click="childClick('schemeCartoon', 3, 3)">工程动画</a></td>
          </tr>
          <tr>
            <td><a @click="childClick('introduction', 4, 1)">企业使命</a></td>
            <td></td>
            <td>
              <a @click="childClick('schemeShowRoom', 3, 3)">项目展厅展馆</a>
            </td>
          </tr>
          <tr>
            <td><a @click="childClick('introduction', 5, 1)">新闻中心</a></td>
          </tr>
          <tr>
            <td><a @click="childClick('introduction', 6, 1)">荣誉资质</a></td>
          </tr>
        </table>

        <div class="rit">
          <img src="../assets/images/home/qr.jpg" />
          <p>九象微信公众号</p>
        </div>
      </div>
    </div>
    <div class="box2">
      广东深圳福田区八卦岭工业区八卦二路524栋5楼整层<br />
      版权归深圳市九象数字科技有限公司所有
      <a
        href="https://beian.miit.gov.cn/#/Integrated/index"
        style="color: #636466"
        >粤ICP备13013171号</a
      >
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    childClick(url, code, id) {
      document.documentElement.scrollTop = 0

      //this.$router.push({name: url, params: {key: code + 1}});
      this.$router.push({ name: 'empty', params: { url: url, key: code + 1 } })
      if (this.idx !== id) {
        this.idx = id
        sessionStorage.setItem('idx', id)
      }
      //else {
      //     this.$emit('change', code + 1);
      // }
    },
  },
}
</script>

<style lang="scss" scoped>
.bottom {
  height: 3.8rem;
  font-size: 0.15rem;
  margin-top: 0.7rem;

  .box1 {
    height: 3rem;
    background: #313234;
    overflow: hidden;

    .main {
      width: 12rem;
      margin: 0.45rem auto 0;
      background: red;

      table {
        float: left;

        td {
          width: 1.65rem;
          height: 0.3rem;

          a {
            cursor: pointer;
            color: #7d7d7d;
            text-decoration: none;
          }

          a:hover {
            color: #bfbfbf;
          }
        }

        .tr {
          color: #bfbfbf;
          font-size: 0.17rem;
          height: 0.5rem;
        }
      }

      .rit {
        float: right;
        text-align: center;
        color: #bfbfbf;

        img {
          width: 1.24rem;
          height: 1.24rem;
          margin: 0.2rem 0 0.1rem;
        }
      }
    }
  }

  .box2 {
    text-align: center;
    height: 0.8rem;
    background: #353637;
    color: #636466;
    line-height: 0.3rem;
    padding-top: 0.13rem;
  }
}
</style>
